var React = require('react');

function LockInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9 13V15M3 19H15C16.1046 19 17 18.1046 17 17V11C17 9.89543 16.1046 9 15 9H3C1.89543 9 1 9.89543 1 11V17C1 18.1046 1.89543 19 3 19ZM13 9V5C13 2.79086 11.2091 1 9 1C6.79086 1 5 2.79086 5 5V9H13Z","stroke":"#1C3133","strokeWidth":"1.5","strokeLinecap":"round"}));
}

LockInline.defaultProps = {"viewBox":"0 0 18 20","fill":"none"};

module.exports = LockInline;

LockInline.default = LockInline;
